import React, { useMemo } from 'react';
import styles from './CircleGauge.module.css';

const CircleGauge = ({
  value = 0,
  max = 10,
  label,
  size = 60,
  strokeWidth = 8,
  percent = false,
  innerTextSize = 18,
  innerTextBold = false,
  mainColor,
  bgColor,
}) => {
  // SVG Geometry calculations
  const radius = (size - strokeWidth) / 2;
  const circumference = useMemo(() => 2 * Math.PI * radius, [radius]);

  // Calculate progress offset
  // strokeDashoffset = circumference - (percent * circumference)
  const percentage = Math.min(Math.max(value / max, 0), 1);
  const strokeDashoffset = circumference - percentage * circumference;

  return (
    <div
      className={styles.gauge_container}
      style={
        mainColor && bgColor
          ? { '--main-color': mainColor, '--main-bg': bgColor }
          : null
      }
    >
      <div
        className={styles.gauge_svg_wrapper}
        style={{ width: size, height: size }}
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={max}
      >
        <svg className={styles.gauge_svg} viewBox={`0 0 ${size} ${size}`}>
          {/* Background Ring */}
          <circle
            className={styles.gauge_circle_bg}
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={strokeWidth}
            style={strokeWidth ? { '--stroke-width': strokeWidth } : null}
          />

          {/* Foreground Progress Ring */}
          <circle
            className={styles.gauge_circle_fg}
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={strokeWidth}
            style={{
              strokeDasharray: circumference,
              strokeDashoffset,
              '--stroke-width': strokeWidth,
            }}
          />
        </svg>

        <div
          className={styles.gauge_text}
          style={{
            fontSize: innerTextSize,
            fontWeight: innerTextBold ? 700 : 400,
          }}
        >
          {percent
            ? `${Number((value / max) * 100).toFixed()}%`
            : `${value}/${max}`}
        </div>
      </div>

      {label && <div className={styles.gauge_label}>{label}</div>}
    </div>
  );
};

export default CircleGauge;
